// extracted by mini-css-extract-plugin
export var colorSquare = "_qg-0";
export var danger = "_qg-5";
export var lightPink = "_qg-8";
export var neutralBlue = "_qg-7";
export var neutralYellow = "_qg-6";
export var normal = "_qg-1";
export var primary = "_qg-2";
export var primaryLight = "_qg-3";
export var solidBlack = "_qg-g";
export var solidGreen = "_qg-b";
export var solidLightBlue = "_qg-d";
export var solidNavy = "_qg-c";
export var solidOrange = "_qg-f";
export var solidPink = "_qg-e";
export var solidRed = "_qg-9";
export var solidYellow = "_qg-a";
export var success = "_qg-4";